import { render } from "./SingleDaySlideItemSingle.vue?vue&type=template&id=4f6cc4f9"
import script from "./SingleDaySlideItemSingle.vue?vue&type=script&lang=js"
export * from "./SingleDaySlideItemSingle.vue?vue&type=script&lang=js"

import "./SingleDaySlideItemSingle.vue?vue&type=style&index=0&id=4f6cc4f9&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__